var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$store.state.isApp)?_c('Header',{staticClass:"Header",attrs:{"id":"app_header"}}):_vm._e(),_c('router-view',{staticClass:"router-view",class:_vm.$store.state.isApp ? 'app_top' : '',attrs:{"id":"app_router"}}),(!_vm.$store.state.isApp)?_c('Footer',{attrs:{"id":"app_footer"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }